module.exports = __webpack_public_path__ + "img/owner-interview.6dde2e5.png";